export const HIDEAWAY_PACKAGE = 'HIDEAWAY';
export const HAVEN_HOLIDAY_PACKAGE = 'HAVEN HOLIDAY';
export const HIDEAWAY = 'hideaway';
export const HAVEN_HOLIDAY = 'haven holiday';
export const HAVEN_HOLIDAY_SHORT = 'haven';
export const HAVEN_HOLIDAY_PRESENTABLE = 'haven holiday';
export const ASCENDING = 'ASC';
export const DESCENDING = 'DESC';
export const PRICE_LOW = 'priceLow';
export const PRICE_HIGH = 'priceHigh';
export const RANK = 'RANK';
export const DATE = 'DATE';
export const GUESTS = 'GUESTS';
export const PARK = 'PARK';
export const ANY = 'any';
export const GTM_EVENT = 'visitor interaction';
export const NOT_SELECTED = 'not selected';
export const PAST_DATE = 'past date';

export const PACKAGE_TYPES = {
  [HIDEAWAY]: 'hideaway',
  [HAVEN_HOLIDAY]: 'haven holiday',
};

export const DEFAULT_AGENCY_ID = 7742;

export const breakPoints = {
  xl: '(min-width: 1401px)',
  lg: '(min-width: 1100px) and (max-width: 1400px)',
  md: '(min-width: 800px) and (max-width: 1099px)',
  sm: '(min-width: 500px) and (max-width: 799px)',
  xs: '(min-width: 0px) and (max-width: 499px)',
};

export const searchResultCardMainImageProfilesV3 = {
  xlarge: 'resultCardMainV3-xl',
  large: 'resultCardMainV3-lg',
  medium: 'resultCardMainV3-md',
  small: 'resultCardMainV3-sm',
  xsmall: 'resultCardMainV3-xs',
};

export const searchResultCardSmallImageProfilesV3 = {
  xlarge: 'resultCardSmallV3-xl',
  large: 'resultCardSmallV3-lg',
  medium: 'resultCardSmallV3-md',
  small: 'resultCardSmallV3-sm',
  xsmall: 'resultCardSmallV3-xs',
};

export const touringSortByOptions = [
  { name: 'Default', id: RANK },
  { name: 'Price (Lowest)', id: ASCENDING },
  { name: 'Price (Highest)', id: DESCENDING },
];

export const flexibleSortByOptions = [
  { name: 'Default', id: RANK },
  { name: 'Price (Lowest)', id: PRICE_LOW },
  { name: 'Price (Highest)', id: PRICE_HIGH },
];

export const AFFILIATE_COOKIE_NAME = 'AffiliatePromo';

export const accommodationDescriptionPrefixes = [
  'new',
  'exclusive',
  'premium',
  'second',
  'seaview',
  'sea view',
  'lakeview',
  'lake view',
  'lakeside',
];

export const accommodationDescriptionPostfixes = [
  'standard',
  'deluxe',
  'prestige',
  'platinum',
  'saver',
  'silver',
  'bronze',
  'gold',
  'signature',
];

export const DATA_LAYER_DEFAULT_EVENT = 'virtual page view';

export const customCampaignMapping = {
  bluelight: {
    AgencyID: '152305',
    PromoCode: 'EMB_BLUELIGHT',
    Campaign: 'bluelight',
  },
  defence: {
    AgencyID: '151514',
    PromoCode: 'EMB_DEFENCE',
    Campaign: 'defence',
  },
  rewardgateway: {
    AgencyID: null,
    PromoCode: 'EMB_REWARDGATEWAY',
    Campaign: 'rewardgateway',
  },
  xexec: {
    AgencyID: null,
    PromoCode: 'EMB_XEXEC',
    Campaign: 'xexec',
  },
  jlp: {
    AgencyID: null,
    PromoCode: 'EMB_JLP',
    Campaign: 'jlp',
  },
};

export const caravanSalesExportEndpoint = `/search-results/v2/api/caravan-sales-export`;
